export default "__VITE_ASSET__C6oKdrsI__"